import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route for /checkout/** — renders child routes directly.
export const Route = createFileRoute("/checkout")({
  component: () => <Outlet />,
});
